const state = {
    person: null,
    podcast: null,
    video: null,
};

const getters = {
    person: state => state.person,
    podcast: state => state.podcast,
    video: state => state.video,
}

const mutations = {
    person(state, record) {
        state.person = record;
    },

    podcast(state, record) {
        state.podcast = record;
    },

    video(state, record) {
        state.video = record;
    },
}

const actions = {
    person({commit}, record) {
        commit('person', record);
    },

    podcast({commit}, record) {
        commit('podcast', record);
    },

    video({commit}, record) {
        commit('video', record);
    },

    clearPerson({commit}) {
        commit('person', null);
    },

    clearPodcast({commit}) {
        commit('podcast', null);
    },

    clearVideo({commit}) {
        commit('video', null);
    },
}

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions,
}
